module.exports = __webpack_public_path__ + "static/media/inlineImage.706ec453.svg";